import injectSheet from 'react-jss';

import ImageWrapper from './component';
import styles from './styles';

export default injectSheet(styles)(ImageWrapper);
